import React from "react";

const EditIcon = ({
  color = "#2B2B2B",
  width = "100%",
  height = "100%"
}) => {

  return (
    <svg
      className="icon editIcon"
      width={width}
      height={height}
      viewBox="0 0 15 16"
      fill="none"
    >
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
          <path
            d="M11.4963454,0.5 C12.0324397,0.5 12.5363098,0.707992874 12.9171418,1.09175438 L12.9171418,1.09175438 L14.4111751,2.5857877 C14.7920071,2.96369025 15,3.46756031 15,4.00365462 C15,4.53974893 14.7890776,5.04361899 14.4111751,5.42152154 L14.4111751,5.42152154 L7.02303384,12.8125923 C6.73594509,13.099681 6.2730877,13.099681 5.98599895,12.8125923 C5.69891019,12.5255035 5.69891019,12.0626461 5.98599895,11.7755574 L5.98599895,11.7755574 L11.8215173,5.94003898 L9.55996102,3.67848266 L1.79391721,11.4445265 C1.56541799,11.6730257 1.44530943,11.9923387 1.46581577,12.3145812 C1.46874525,12.3292286 1.46874525,12.3468054 1.46874525,12.3614528 L1.46874525,12.3614528 L1.46581577,14.0341842 L3.1385472,14.0283253 C3.15319459,14.0283253 3.17077145,14.0312547 3.18541883,14.0312547 C3.50766132,14.0517611 3.82697432,13.9316525 4.05547353,13.7031533 C4.34256229,13.4160646 4.80541967,13.4160646 5.09250843,13.7031533 C5.37959719,13.9902421 5.37959719,14.4530995 5.09250843,14.7401882 C4.5710615,15.2616351 3.85333961,15.537006 3.11804086,15.4959933 L3.11804086,15.4959933 L0.733446497,15.4989228 C0.53717153,15.4989228 0.352614473,15.4227564 0.214929049,15.285071 C0.0772436249,15.1473855 0.00107722019,14.959899 0.00107722019,14.7665535 L0.00107722019,14.7665535 L0.00400669729,12.3819591 C-0.0370059822,11.6466604 0.238364866,10.9289385 0.75981179,10.4074916 L0.75981179,10.4074916 L10.0784785,1.0888249 C10.456381,0.707992874 10.9602511,0.5 11.4963454,0.5 Z M14.2676307,14.0341842 C14.6718986,14.0341842 15,14.3622857 15,14.7665535 C15,15.1708213 14.6718986,15.4989228 14.2676307,15.4989228 L14.2676307,15.4989228 L7.66165985,15.4989228 C7.25739201,15.4989228 6.92929057,15.1708213 6.92929057,14.7665535 C6.92929057,14.3622857 7.25739201,14.0341842 7.66165985,14.0341842 L7.66165985,14.0341842 Z M11.4992749,1.96473855 C11.352801,1.96473855 11.2180451,2.02039862 11.1155134,2.12293032 L11.1155134,2.12293032 L10.5969959,2.64144776 L12.8585522,4.90300409 L13.3770697,4.38448664 C13.587992,4.17356429 13.587992,3.82788599 13.3770697,3.61696364 L13.3770697,3.61696364 L11.8830364,2.12293032 C11.7805047,2.02039862 11.6428192,1.96473855 11.4992749,1.96473855 Z"
            fill={color}
            fillRule="nonzero"
          >
          </path>
      </g>
    </svg>
  );
};

export default EditIcon;
